import HTTP from "../HTTP";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async index(number_page, field_sort, text_search) {
    try {
      let accountable = "&filter[accountable_type]=Manager";
      let search = "";
      let page = `&page[number]=${number_page}`;
      let sort = "";

      if (text_search.length >= 3)
        search = `&filter[text_search]=${text_search}`;

      let results = await HTTP.normal.get(
        `/accounts?include=profile${accountable}${search}${page}${sort}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os donamakers!";
    }
  },

  async create(payload) {
    try {
      let data = {
        data: payload
      };

      await HTTP.normal.post("/managers", data);
      return true;
    } catch (e) {
      throw e.response.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/donamakers.js